import { FC, RefObject } from 'react';
import Slider from 'react-slick';
import cn from 'classnames';
import ls from 'localstorage-slim';
import { Together } from '../../containers/Together/Together';
import { Login } from '../../containers/Login/Login';
import { togglePage } from '../../helpers/togglePage';
import { Register } from '../../containers/Register/Register';

import './SliderComponent.scss';
import 'slick-carousel/slick/slick.css';

type Props = {
  sliderRef: RefObject<Slider>;
};

export const SliderComponent: FC<Props> = ({ sliderRef }) => {
  const { hash } = window.location;

  const getInitIndex = () => {
    if (ls.get('isMenuOpen')) {
      return;
    }

    switch (hash) {
      case `#menu-0`:
        return 0;
      case `#menu-1`:
        return 1;
      case `#menu-2`:
        return 2;

      default:
        return 0;
    }
  };

  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    swipeToSlide: true,
    initialSlide: getInitIndex(),
    className: 'slider-component__slider',
    afterChange: (index: number) => {
      togglePage('#menu-' + ++index);
    },
  };

  return (
    <div
      className={cn('slider-component', {
        'slider-component--open': hash.includes('menu'),
        'slider-component--close': !hash.includes('menu'),
      })}
    >
      <Slider ref={sliderRef} {...settings}>
        <div className="slider-component__section">
          <Register />
        </div>
        <div className="slider-component__section">
          <Together />
        </div>
        <div className="slider-component__section">
          <Login />
        </div>
      </Slider>
    </div>
  );
};
